// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Legend Container */
.status-legend {
    background: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--shadow-2);
    padding: 0.5rem;
    margin: 1rem auto;
    text-align: center;
    border: 3px solid var(--clr-primary-5);
  }
  
  /*Legend Title */
  .legend-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--clr-grey-2);
    margin-bottom: 1rem;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  
  /*Legend Items - Now in Row */
  .legend-items {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap; 
  }
  
  /* Individual Legend Entry */
  .legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  /* Circular Status Color Indicator */
  .legend-color {
    width: 16px;
    height: 16px;
    border-radius: 50%; 
    display: inline-block;
    border: 2px solid var(--clr-grey-5);
  }
  
  /* Status Label */
  .legend-label {
    font-size: 1rem;
    color: var(--clr-grey-3);
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Scheduling/components/AdminView/StatusLegend.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA,oCAAoC;EACpC;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,mCAAmC;EACrC;;EAEA,iBAAiB;EACjB;IACE,eAAe;IACf,wBAAwB;EAC1B","sourcesContent":["/*Legend Container */\n.status-legend {\n    background: var(--clr-white);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-2);\n    padding: 0.5rem;\n    margin: 1rem auto;\n    text-align: center;\n    border: 3px solid var(--clr-primary-5);\n  }\n  \n  /*Legend Title */\n  .legend-title {\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: var(--clr-grey-2);\n    margin-bottom: 1rem;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n  }\n  \n  /*Legend Items - Now in Row */\n  .legend-items {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    flex-wrap: wrap; \n  }\n  \n  /* Individual Legend Entry */\n  .legend-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  /* Circular Status Color Indicator */\n  .legend-color {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%; \n    display: inline-block;\n    border: 2px solid var(--clr-grey-5);\n  }\n  \n  /* Status Label */\n  .legend-label {\n    font-size: 1rem;\n    color: var(--clr-grey-3);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
